import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/app/terms/page.tsx");
